import styled from 'styled-components';

import { media } from '~/src/common/theme/deprecated';

import { TREEVIEW_SPACE } from '../constants';

import * as C from './Content/layout';
import * as H from './Header/layout';

export const Container = styled.div`
  margin: 0;
  padding: 0;

  /* Surcharge des marges pour compenser l'absence de Treeview */
  ${media.XL`
    ${H.Container} {
      padding-left: ${TREEVIEW_SPACE / 2}px;
      padding-right: ${TREEVIEW_SPACE / 2}px;
    }
    ${C.Container} {
      margin-left: ${TREEVIEW_SPACE / 2}px;
      margin-right: ${TREEVIEW_SPACE / 2}px;
    }
  `}
`;
